import { BCMSRecord, BCMSRecordProperty } from "bcms-react";


/**
 * @class NotificationCategory
 * @classdesc Class definition for record type from model
 * @param {OBJECT} record - record from the model to init class
 * @extends BCMSRecord
 * @example const notification = new NotificationCategory(model.notificationHistory[0]);
 * 
 * @property {NUMBER} _id - The id of the notification 
 * @property {STRING} _name - The name of the notification 
 * @property {STRING} _description - description for category
*/
export default class NotificationCategory extends BCMSRecord {
    _id;
    _name;
    _limited;
    _description;
  

    constructor(record) {
        super(record);
    }


    /**
    * @function ByName
    * @instance
    * @param {OBJECT} model - The model object
    * @returns {Notification}
    * @description Returns the category for the given name.
    * @memberof NotificationCategory
    */
    static initByName(name){
            return NotificationCategory.initAll().filter((category)=>{
               return category.name === name;
            })[0]
    }
}
NotificationCategory.define({
    "recordType" : "notificationCategory",
    "recordIDProp" : "id",
    "className" : "NotificationCategory",
    "recordProperties" : [
        /**
         * @name
         * @instance
         * @property get {NUMBER} - gets the id of the notification 
         * @property set {NUMBER} - sets the id of the notification 
         * @memberof NotificationCategory
         */
        BCMSRecordProperty.mapToNumber("id", "_id"),

        /**
         * @name
         * @instance
         * @property get {STRING} - gets the name of the notification 
         * @property set {STRING} - sets the name of the notification 
         * @memberof NotificationCategory
         */
        BCMSRecordProperty.mapToString("name", "_name"),

        /**
         * @name
         * @instance
         * @property get {STRING} - gets the description of the notification 
         * @property set {STRING} - sets the description of the notification
         */
        BCMSRecordProperty.mapToString("description", "_description")
   
        
    ]
        
});